import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo6/escudo1.png";
import Imagen2 from "../../../images/modulo6/escudo2.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 7.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[6];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo6.content[0].activities[7].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[7].path}`,
    titlePrev: `${modulo6.content[0].activities[5].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Observa las siguientes imágenes.</li>
      </ul>
      <div className="row mt-5 align-items-center">
        <div className="col-md-4 offset-md-1 col-xs-12 text-center">
          <div>Primer escudo nacional</div>
          <img src={Imagen1} alt="escudo" className="img-fluid mt-2" />
        </div>
        <div className="col-md-4 offset-md-1 col-xs-12 text-center">
          <div>Escudo nacional actual</div>
          <img src={Imagen2} alt="escudo" className="img-fluid mt-2" />
        </div>
      </div>
      <ul className="mt-5 mb-4">
        <li>
          Ahora conversa con un compañero, compañera o familiar y respondan lo
          siguiente:
        </li>
      </ul>
      <div className="row">
        <div className="col-md-10 col-12">
          <p>¿Qué elementos aparecen en el primer escudo?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Qué elementos aparecen en el escudo actual?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Creen que los elementos que aparecen en ambos escudos representan
            bien al Perú?
          </p>
          <textarea className="form-control mb-4" rows={3} />
        
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea la primera indicación y observen las imágenes. Aclare que se trata
          de dialogar sobre las preguntas. Hay que destacar en el primer escudo
          el sol, los Andes y el mar; y en el escudo actual, la vicuña, el árbol
          de la quina y la cornucopia. Explique que todos los elementos son
          representativos de las riquezas del Perú.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
